export function customCeil(num) {
  const digits = Math.floor(Math.log10(num)); // Number of digits minus one
  const factor = Math.pow(10, digits); // 10 to the power of that number
  const rounded = Math.ceil(num / factor) * factor; // Round up and multiply back
  return rounded;
}

export function getyTicks(num) {
  // const max = num;
  // if (num <= 10) {
  //   return num;
  // }
  // let result = 5;
  // while (num >= 100) {
  //   num = num / 10;
  //   result = result * 10;
  // }
  // return max / result;

  return num < 10 ? num : 5;
}

export const initalColors = [
  "#FF6F61", // Coral
  "#6B5B95", // Purple
  "#88B04B", // Olive Green
  "#009B77", // Teal
  "#92A8D1", // Cool Blue
  "#9B2335", // Maroon
  "#955251", // Warm Brown
  "#B565A7", // Orchid
  "#DD4124", // Vibrant Orange
  "#45B8AC", // Aquamarine
  "#F7CAC9", // Pale Pink
  "#EFC050", // Golden Yellow
  "#5B5EA6", // Classic Blue
  "#BC243C", // Deep Red
  "#98B4D4", // Sky Blue
];

export function arrSum(arr = [1, 2]) {
  return arr.reduce((a, b) => a + b, 0);
}
